'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchHomeDataIfNeeded = exports.shouldFetchHomeData = exports.getHomeData = exports.LOAD_HOME_DATA_SUCCESS = exports.LOAD_HOME_DATA_REQUEST = exports.LOAD_HOME_DATA_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _cardData = require('../modules/cardData');

var _config = require('../modules/config');

var _filteredItems = require('./filteredItems');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _shuffle = require('lodash/shuffle');

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_HOME_DATA_FAIL = exports.LOAD_HOME_DATA_FAIL = 'la/domain/home/LOAD_FAIL';
var LOAD_HOME_DATA_REQUEST = exports.LOAD_HOME_DATA_REQUEST = 'la/domain/home/LOAD_REQUEST';
var LOAD_HOME_DATA_SUCCESS = exports.LOAD_HOME_DATA_SUCCESS = 'la/domain/home/LOAD_SUCCESS';

// reducer
var DEFAULT_STATE = {
    acn: {},
    categories: [],
    featuredCatalogs: [],
    loading: false,
    trendingItems: [],
    trustMetrics: {},
    upcomingCatalogs: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var categories = void 0;
    var featuredCatalogs = void 0;

    switch (action.type) {
        case LOAD_HOME_DATA_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_HOME_DATA_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_HOME_DATA_SUCCESS:
            // categories
            if (action.payload.categories) {
                categories = action.payload.categories.map(function (x) {
                    // add in the label until the api returns it
                    return (0, _extends3.default)({
                        label: x.title
                    }, x);
                });
            } else {
                categories = [];
            }

            // featuredCatalogs
            if (Array.isArray(action.payload.featuredCatalogs)) {
                if ((0, _isInteger2.default)(action.payload.featuredCatalogs[0])) {
                    // old way, an array of ints
                    featuredCatalogs = [].concat((0, _toConsumableArray3.default)(action.payload.featuredCatalogs));
                } else {
                    // new way, an array of objects
                    featuredCatalogs = action.payload.featuredCatalogs.map(function (x) {
                        return x.catalogId;
                    });
                }
            } else {
                // bad, not an array
                featuredCatalogs = [];
            }
            // TODO: make this reducer pure by moving the shuffle to the selector
            featuredCatalogs = (0, _shuffle2.default)(featuredCatalogs);
            return (0, _extends3.default)({}, state, {
                acn: (0, _extends3.default)({}, action.payload.acn),
                categories: categories,
                featuredCatalogs: featuredCatalogs,
                loading: false,
                trendingItems: [].concat((0, _toConsumableArray3.default)(action.payload.trendingItems)),
                trustMetrics: (0, _extends3.default)({}, action.payload.siteStatistics),
                upcomingCatalogs: [].concat((0, _toConsumableArray3.default)(action.payload.upcomingCatalogs))
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.home;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};

var getHomeData = exports.getHomeData = (0, _reselect.createSelector)([stateSelector, globalStateSelector], function (state, globalState) {
    return {
        acn: state.acn,
        categories: state.categories,
        featuredCatalogs: (0, _cardData.getCatalogCardDatas)(globalState, state.featuredCatalogs),
        homeTrustMetrics: state.trustMetrics,
        trendingItems: (0, _filteredItems.getTrendingItemsByBids)(globalState, state.trendingItems),
        upcomingCatalogs: (0, _cardData.getCatalogCardDatas)(globalState, state.upcomingCatalogs, true)
    };
});

var shouldFetchHomeData = exports.shouldFetchHomeData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return (0, _isEmpty2.default)(state.featuredCatalogs);
});

/* ACTION CREATORS */
var loadHomeData = function loadHomeData() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_HOME_DATA_REQUEST
                            });
                            _context.next = 6;
                            return _api.Home.fetchHomeData({ deployment: deployment });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_HOME_DATA_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_HOME_DATA_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchHomeDataIfNeeded = exports.fetchHomeDataIfNeeded = function fetchHomeDataIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchHomeData(getState())) {
            return dispatch(loadHomeData());
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/home.js
// module id = TSUT
// module chunks = 46